import { motion, useScroll, useTransform } from 'framer-motion';

const Butterfly = ({ style, delay = 0 }) => (
  <motion.div
    className="absolute"
    style={style}
    animate={{ y: [0, -16, 0], rotate: [0, 6, 0] }}
    transition={{ duration: 7, repeat: Infinity, ease: 'easeInOut', delay }}
  >
    <svg width="34" height="27" viewBox="0 0 60 48" fill="none">
      <path d="M30 24 C18 4 2 8 6 22 C9 33 22 30 30 24 Z" fill="#C29A3B" opacity="0.8" />
      <path d="M30 24 C42 4 58 8 54 22 C51 33 38 30 30 24 Z" fill="#A31621" opacity="0.8" />
      <ellipse cx="30" cy="25" rx="2.2" ry="7.5" fill="#560A10" />
    </svg>
  </motion.div>
);

export default function AlponaBackground() {
  const { scrollY } = useScroll();
  const y = useTransform(scrollY, [0, 900], [0, -70]);

  return (
    <>
      <div className="rail rail-left" />
      <div className="rail rail-right" />
      <div className="alpona alpona-bl" />
      <div className="alpona alpona-br" />
      <motion.div className="butterflies" style={{ y }}>
        <Butterfly style={{ left: '8%', top: '17%' }} />
        <Butterfly style={{ right: '8%', top: '12%' }} delay={1.6} />
      </motion.div>
    </>
  );
}
